import infoIcon from '../../assets/svgs/info-icon.svg';

type MessageProps = {
    message: string;
};

const Message: React.FC<MessageProps> = ({ message }) => {
    return (
        <div className="flex items-start mt-10 gap-2 p-4 rounded-lg bg-primary/10 border border-primary/10">
            <img src={infoIcon} alt="info" aria-hidden="true" className="w-4 h-4" />
            <p className="text-custom-text-placeholder text-xs !leading-none mt-0.5 font-medium">
                {message}
            </p>
        </div>
    );
};

export default Message;
